import { useMutation, useQuery } from '@tanstack/react-query';
import { getConstructionFee, saveConstructionFee } from 'app/edozvola/cases/construction-fee/service/construction-fee.service';
import { showToast } from 'app/shared/util/toast.util';
import { queryClient } from 'app/app';
import { ConstructionFeeModel } from 'app/edozvola/cases/construction-fee/model/construction-fee.model';
import { toast } from 'react-toastify';
import success = toast.success;
import error = toast.error;
import { getSegments, saveSegments } from 'app/edozvola/cases/case-segment/service/case-segment.service';
import { CaseSegmentModel, CaseSegmentsModel } from 'app/edozvola/cases/case-segment/model/case-segment.model';
import {messages} from "app/config/constants";

export const fetchSegmentsQuery = (caseUuid: string) => {
  return useQuery({
    queryKey: ['segments', caseUuid],
    queryFn: () => getSegments(caseUuid),
    enabled: !!caseUuid,
  });
};

export const saveSegmentsQuery = (caseUuid: string, resetFunction) => {
  return useMutation({
    mutationFn: (segments: CaseSegmentsModel) => {
      return saveSegments(caseUuid, segments);
    },
    onSuccess: (data, variables) => {
      showToast(success, messages.DATA_SAVED);
      resetFunction({ values: variables });
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};
